import React, { useState, useEffect } from "react";
import wrappercss from "./Wrapper.module.css";
import ListItem from "../listitem/ListItem";
import NotificationActions from "../notfication_actions/NotificationActions";
import NotificationListItem from "../notification_listitem/NotificationListItem";
import NotificationDetails from "../notification_details/NotificationDetails";
import {getNotifications} from "../../../../network/index";

function Wrapper(props) {
    
    const [info, setInfo] = useState({});
    const [order, setOrder] = useState([]);
   
  
        return (
            <div className={wrappercss.grid_container}>
                <div className={wrappercss.grid_item1}>
                    <h1 className={wrappercss.wrapperh1}>Notifications</h1>
                    <div id={wrappercss.allitems}>
                        <ListItem
                            icon={''}
                            title={"All Items"}
                            selected={false}
                        />
                        <ListItem
                            icon={"/icons/ellipse_purple.svg"}
                            title={"Orders"}
                            selected={false}
                        />
                        <ListItem
                            icon={"/icons/ellipse_pink.svg"}
                            title={"Products"}
                            selected={false}
                        />
                        <ListItem
                            icon={"/icons/ellipse_green.svg"}
                            title={"Inbox"}
                            selected={false}
                        />
                        <div className={wrappercss.vertspacer}></div>
                        <ListItem
                            icon={"/icons/flagged.svg"}
                            title={"Flagged"}
                            selected={false}
                        />
                        <ListItem
                            icon={"/icons/archived.svg"}
                            title={"Archived"}
                            selected={false}
                        />
                        <div className={wrappercss.vertspacer}></div>
                        <ListItem
                            icon={''}
                            title={"Today"}
                            selected={false}
                        />
                        <ListItem
                            icon={''}
                            title={"This Week"}
                            selected={true}
                        />
                        <ListItem
                            icon={''}
                            title={"This Month"}
                            selected={false}
                        />
                        <ListItem
                            icon={''}
                            title={"This Quarter"}
                            selected={false}
                        />
                    </div>
                </div>
                <div className={wrappercss.grid_item2}>
                    <div id={wrappercss.notlist}>
                        <NotificationActions setInfo={setInfo} setOrder={setOrder}/>
                        {/* <NotificationListItem/> */}
                    </div>
                </div>
                {/* <NotificationListItem/> */}

                <div className={wrappercss.grid_item3}>
                    <h1 className={wrappercss.wrapperh1det}>Details</h1>
                    <div id={wrappercss.details} >
                        <NotificationDetails info={info} order={order}/>
                    </div>
                </div>


            </div>
        )

}

export default Wrapper;